import {Entity} from 'app/core/main.entity';
import {SwitchItem, SwitchItemTitlePrefix} from './switch.entity';
import {AppColorList} from 'app/entities/enums';
import {Type} from 'class-transformer';
import 'reflect-metadata';

export class Dictionary extends Entity {
  code?: string;
  id: number | string;

  // @todo refactor to keep one after we will rework Profile section
  name?: string;
  title?: string;

  selectedTitle?: string = null;

  color?: AppColorList | string = null;
  selectedColor?: AppColorList | string = null;
  selectedBackground?: AppColorList | string = null;

  @Type(() => SwitchItemTitlePrefix)
  prefix?: SwitchItemTitlePrefix = null;

  @Type(() => Dictionary)
  items?: Dictionary[] = [];

  // @todo refactor to keep one after we will rework Profile section
  order?: number;
  profile_field_id?: number;

  getSwitchItem?(): SwitchItem {

    const data: Partial<SwitchItem> = {
      id: this.id,
      title: this.getTitle()
    };

    if (this.selectedTitle) {
      data.selectedTitle = this.selectedTitle;
    }

    if (this.color) {
      data.color = this.color;
    }

    if (this.selectedColor) {
      data.selectedColor = this.selectedColor;
    }

    if (this.selectedBackground) {
      data.selectedBackground = this.selectedBackground;
    }

    if (this.prefix) {
      data.prefix = this.prefix;
    }

    if (this.items) {
      data.subItems = this.items.map(subItem => subItem.getSwitchItem());
    }

    const item = new SwitchItem(data);
    item.data = {
      code: this.code,
      id: this.id,
      name: this.getTitle(),
      title: this.getTitle(),
      order: this.order,
      profile_field_id: this.profile_field_id,
    };

    return item;
  }

  private getTitle?() {
    return this.title ? this.title : this.name;
  }
}
